import { axiosInstance } from './base'

export function sendContactUs (data) {
  return axiosInstance.post('contact-us/', data)
}
